<template>
    <v-autocomplete
        class="full-width"
        v-model="internalValue"
        :items="displayItems"
        :search-input.sync="search"
        label="Trigger"
        clearable
        hide-selected
        allow-overflow
        dense
        hide-details="auto"
        outlined
        item-text="label"
        item-value="value"
        placeholder="Add or choose a trigger"
        @change="emitChange"
        @blur="handleBlur"
        @keydown.enter.prevent="handleEnter"
    />
</template>

<script>
export default {
    name: "TriggerSelector",
    props: {
        /**
         * The trigger value can be a string, null, or undefined.
         */
        value: {
            type: [String, null],
            default: null,
        },
        /**
         * List of predefined trigger options
         * e.g. ["click", "hover", "timer", "keypress"]
         */
        availableTriggers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            search: "",
            internalValue: this.value || null,
        };
    },
    computed: {
        displayItems() {
            // Map triggers to { label, value }
            const items = this.availableTriggers.map(t => ({ label: t, value: t }));

            // If current value is not in list, add it as a synthetic option
            if (
                this.internalValue &&
                this.internalValue.length &&
                !items.find(i => i.value === this.internalValue)
            ) {
                items.push({ label: this.internalValue, value: this.internalValue });
            }

            return items;
        },
    },
    watch: {
        value(newVal) {
            this.internalValue = newVal || null;
        },
    },
    methods: {
        emitChange() {
            this.$emit("input", this.internalValue);
            this.$emit("change", this.internalValue);
        },
        handleBlur() {
            const text = this.search?.trim();
            if (text && !this.availableTriggers.includes(text)) {
                this.internalValue = text;
                this.emitChange();
            }
            this.search = "";
        },
        handleEnter() {
            const text = this.search?.trim();
            if (text) {
                this.internalValue = text;
                this.emitChange();
                this.search = "";
            }
        },
    },
};
</script>
